// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { useModelIDsQuery } from "../../../Utilities";

export type GenericModelLinkProps<T extends Models.ModelWithID> = Omit<Models.GenericLinkProps<T>, "useModelIDsQuery">;

export function GenericModelLink<T extends Models.ModelWithID>(props: GenericModelLinkProps<T>) {
	return <Models.GenericLink useModelIDsQuery={useModelIDsQuery} {...props} />;
}
